<ngx-spinner [name]="spinner1" [fullScreen]="true"><span class="badge badge-info p-2">Autorisierung wird durchgeführt...</span></ngx-spinner>
<div class="container g-3 ">
  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" *ngIf="formReady">

    <div class="form-group row mb-2">
      <label for="firstName" class="ps-0" i18n="@@FirstnameLabel">Vorname</label>
      <input type="text" id="firstName" [readonly]="this.entity.email != null && this.entity.email?.length > 0" formControlName="firstName" class="form-control" i18n-placeholder="@@FirstName" placeholder="Vorname" />

      <div class="error">
        <em *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'required')" i18n="@@FirstnameRequiredError">
          Vorname wird benötigt
        </em>
        <em *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'pattern')" i18n="@@IncorrectInputError">
          Falsche Eingabe
        </em>
        <em *ngIf="formService.validateControl('firstName') && formService.hasError('firstName', 'maxlength')" i18n="@@ExceededMaxLengthError">
          Die Eingabe darf maximal 50 Zeichen lang sein
        </em>
      </div>
    </div>

    <div class="form-group row mb-2">
      <label for="lastName" class="ps-0" i18n="@@LastnameLabel">Nachname</label>
      <input type="text" id="lastName" [readonly]="this.entity.email != null && this.entity.email?.length > 0" formControlName="lastName" class="form-control" i18n-placeholder="@@LastName" placeholder="Nachname" />

      <div class="error">
        <em *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'required')" i18n="@@LastnameRequiredError">
          Nachname wird benötigt
        </em>
        <em class="invalid-tooltip" *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'pattern')" i18n="@@IncorrectInputError">
          Falsche Eingabe
        </em>
        <em class="invalid-tooltip" *ngIf="formService.validateControl('lastName') && formService.hasError('lastName', 'maxlength')" i18n="@@ExceededMaxLengthError">
          Die Eingabe darf maximal 50 Zeichen lang sein
        </em>
      </div>
    </div>


    <div class="form-group row mb-2" *ngIf="this.entity.email != null && this.entity.email?.length > 0">
      <label for="email" class="ps-0" i18n="@@E_MailLabel">
        E-Mail
      </label>
      <input type="text" id="email"  [readonly]="this.entity.email != null && this.entity.email?.length > 0" formControlName="email" class="form-control" i18n-placeholder="@@EmailPlaceholder" placeholder="E-Mail" />

      <div class="error">
        <em *ngIf="formService.validateControl('email') && formService.hasError('email', 'required')" i18n="@@E-MailRequiredError">E-Mail wird benötigt</em>
        <em *ngIf="formService.validateControl('email') && formService.hasError('email', 'email')" i18n="@@E-MailIncorrectInputError">Keine gültige E-Mail</em>
      </div>
    </div>

    <div class="form-group row mb-2">
      <label for="tags" class="ps-0">
        <span i18n="@@AssociatedPricing" i18n-ngbTooltip="@@AssociatedPricingTooltip" ngbTooltip="Für diesen Tarif muss der Benutzer seine Zahlungsdaten angeben um an autorisierten Ladestationen laden zu können. Benutzer ohne Tarif können kostenlos laden.">
          Zugeordneter Tarif
        </span>
      </label>
      <input type="text" id="pricing" formControlName="pricingId" class="form-control" i18n-placeholder="@@AssociatedPricingPlaceholder" placeholder="Kein zugeordneter Tarif" />
    </div>

    <div class="form-group row mb-2">
      <label for="tags" i18n="@@EditUserAssignedRfidCardsLabel" class="ps-0">
        Zugeordnete RFID-Karten
      </label>
      <ng-select [items]="rfidCardsFiltered" id="select_rfid_cards"
                 i18n-[placeholder]="@@AssociatedRfidCards"
                 [placeholder]="'Zugeordnete RFID-Karten'"
                 multiple="true"
                 [closeOnSelect]="false"
                 [clearSearchOnAdd]="true"
                 [hideSelected]="true"
                 appendTo="body"
                 bindLabel="idTag"
                 i18n-notFoundText="@@NoEntriesAvailable"
                 notFoundText="Keine Einträge vorhanden"
                 formControlName="rfidCards"
                 (change)="rfidChanged()">
      </ng-select>
    </div>
    <div *ngIf="formService.form.get('rfidCards').value.length < 1"
      class="d-flex mb-2 align-items-center gap-2 rounded" style="background-color: rgb(255 193 7 / .2);">
      <span class="rounded bg-warning px-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-rfid-card">
          <path d="M3,4h18c1.1,0,2,0.9,2,2v12c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2V6C1,4.9,1.9,4,3,4z"/>
          <path d="M5.6,10.4c3.5-3.5,9.2-3.5,12.7,0"/>
          <circle cx="12" cy="15.3" r="1"/>
          <path d="M16.1,12.6c-2.3-2.3-5.9-2.3-8.2,0"/>
        </svg>
      </span>
      <span>Keine RFID-Karte zugeordnet</span>
    </div>

    <div class="form-group row mb-2">
      <label for="tags" i18n="@@EditUserAssignedCharginggourpsLabel" class="ps-0">
        Zugeordnete Ladestationsgruppen
      </label>
      <ng-select [items]="chargingGroups" id="select_charging_group"
                 i18n-[placeholder]="@@AssociatedChargingGroups"
                 [placeholder]="'Zugeordnete Ladestationsgruppen'"
                 multiple="true"
                 [closeOnSelect]="false"
                 [clearSearchOnAdd]="true"
                 [hideSelected]="true"
                 appendTo="body"
                 bindLabel="name"
                 i18n-notFoundText="@@NoEntriesAvailable"
                 notFoundText="Keine Einträge vorhanden"
                 formControlName="chargingGroups"
                 (change)="chargingGroupChanged()">
      </ng-select>
    </div>

    <div class="form-group row mb-2">
      <label for="tags" i18n="@@EditUserAllowedChargingstationsLabel" class="ps-0">
        Zugeordnete Ladestationen
      </label>
      <ng-select #chargingStationSelect id="select_charging_stations"
                 [items]="filteredChargingStations"
                 multiple="true"
                 i18n-[placeholder]="@@ChargingstationsForUser"
                 [placeholder]="'Zugeordnete Ladestationen'"
                 [closeOnSelect]="false"
                 [clearSearchOnAdd]="true"
                 [hideSelected]="true"
                 [selectableGroupAsModel]="false"
                 appendTo="body"
                 bindLabel="name"
                 i18n-notFoundText="@@NoEntriesAvailable"
                 notFoundText="Keine Einträge vorhanden"
                 formControlName="chargingStations"
                 (change)="chargingStationChanged()">
      </ng-select>
    </div>
    <div *ngIf="formService.form.get('chargingGroups').value.length < 1 && formService.form.get('chargingStations').value.length < 1"
      class="d-flex mb-2 align-items-center gap-2 rounded" style="background-color: rgb(255 193 7 / .2);">
      <span class="rounded bg-warning px-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-charging-station">
          <path d="M3,22V4c0-1.1,0.9-2,2-2h7c1.1,0,2,0.9,2,2v18H3z" />
          <path d="M16,22H1" />
          <path d="M14,9c4,0,3,4,3,8s6,4,6,0s-3-4-3-10" />
          <path d="M22,5c0,0,0,2-2,2s-2-2-2-2h2H22z" />
          <path d="M18,4c0,0.6,0,1,0,1S18,4.6,18,4s0-1,0-1S18,3.4,18,4z" />
          <path d="M22,4c0,0.6,0,1,0,1S22,4.6,22,4s0-1,0-1S22,3.4,22,4z" />
        </svg>
      </span>
      <span>Keine Ladestation zugeordnet</span>
    </div>

    <div class="form-group row mb-2" *ngIf="chargingPowerProfiles.length > 0">
      <label for="tags" i18n="@@EditUserAllowedChargingPowerProfileLabel" class="ps-0">
        <span ngbTooltip="Das Ladeleistungsprofil steuert die Ladeleistung von Ladevorgängen des Benutzers.">
          Zugeordnetes Ladeleistungsprofil
        </span>
      </label>
      <ng-select #chargingPowerProfileSelect id="select_charging_power_profile"
                 [items]="chargingPowerProfiles"
                 appendTo="body"
                 bindLabel="name"
                 i18n-notFoundText="@@NoEntriesAvailable"
                 notFoundText="Keine Einträge vorhanden"
                 [clearable]="false"
                 formControlName="chargingPowerProfile"
                 (change)="chargingPowerProfileChanged()">
      </ng-select>

      <span *ngIf="this.formService.form && this.formService.form.get('chargingPowerProfile').value"
            style="display: flex; gap: .25rem; margin-top: .5rem; font-weight:600" class="ps-0">
        {{ entity.fullName ? entity.fullName : 'Dieser Benutzer' }} lädt
        <charging-power-profile-badge [profile]="this.formService.form.get('chargingPowerProfile').value">
        </charging-power-profile-badge>
      </span>
    </div>

    <div class="row mb-2">
      <div class="form-check mb-2" *ngIf="this.entity.email == null || this.entity.email?.length == 0">
        <input type="checkbox" id="addNewEmail" class="form-check-input"
               (change)="onIsAddingNewEmailChange()" value="isAddingNewEmail">
        <label for="addNewEmail" class="form-check-label" i18n="@@AddNewEmail">
          E-Mail-Adresse hinzufügen und Einladungs-E-Mail senden
        </label>
      </div>
        <label for="email" i18n="@@E_MailLabel" class="ps-0" *ngIf="isAddingNewEmail">
          E-Mail
        </label>
        <input *ngIf="isAddingNewEmail" type="text" id="newEmail" formControlName="newEmail" class="form-control" i18n-placeholder="@@NewEmailPlaceholder" placeholder="E-Mail" />

        <div class="error">
          <em *ngIf="formService.validateControl('newEmail') && formService.hasError('newEmail', 'required')" i18n="@@E-MailRequiredError">E-Mail wird benötigt</em>
          <em *ngIf="formService.validateControl('newEmail') && formService.hasError('newEmail', 'email')" i18n="@@E-MailIncorrectInputError">Keine gültige E-Mail</em>
        </div>
    </div>
    <div class="row mb-2">
      <label for="organisationMail" class="ps-0">E-Mail-Adresse für monatliche Lieferscheinversendung (Dienstwagen)</label>
      <input type="email" id="organisationMail" formControlName="organisationMail" class="form-control" i18n-placeholder="@@OragnisationMailPlaceholder" placeholder="z.B. verwaltung@firma-xyz.de"/>
    </div>
  </form>
</div>
